export const apiMetadataItemBlueprint = () => {
    return new class {
        __FOR_TRACKING_ONLY_MEDIA_ID = undefined;
        _airDate = undefined;
        _airDateISO = undefined;
        _editDate = undefined;
        _firstIngestDate = undefined;
        _ingestDate = undefined;
        _lastModifiedDate = undefined;
        _pubDate = undefined;
        _pubDateISO = undefined;
        addOns;
        airDate = undefined;
        amazonESTURL = undefined;
        appleWatchListShowKey = undefined;
        assetType = undefined;
        availableForProfileTypes = undefined;
        brand = undefined;
        category = undefined;
        cbsShowId = undefined;
        childContentId = undefined;
        closedCaptionUrl = undefined;
        cmsAccountId = undefined;
        contentId = undefined;
        copyright = undefined;
        daistreamKey = undefined;
        description = undefined;
        deviceType = undefined;
        downloadCountrySet = undefined;
        duration = undefined;
        editDate = undefined;
        embeddable = undefined;
        endCreditsChapterTime = undefined;
        episodeNum = undefined;
        excludeNielsenTracking;
        exclusive;
        expired;
        firstIngestDate = undefined;
        fullEpisode;
        genre = undefined;
        ingestDate = undefined;
        isLive;
        isProtected;
        isProductPlacement;
        itunesESTURL = undefined;
        label = undefined;
        lastModifiedDate = undefined;
        mediaAvailableDate = undefined;
        mediaAvailableDateEpoch = undefined;
        mediaType = undefined;
        pid = undefined;
        playbackEvents = undefined;
        playerLocUrl = undefined;
        premiumAudioAvailable = undefined;
        premiumFeatures = undefined;
        primaryCategory = undefined;
        primaryCategoryName = undefined;
        pubDate = undefined;
        rating = undefined;
        regionalRatings = undefined;
        restriction = undefined;
        seasonNum = undefined;
        seriesTitle = undefined;
        shortDescription = undefined;
        showPageUrl = undefined;
        status = undefined;
        streamingUrl = undefined;
        subscriptionLevel = undefined;
        thumbnail = undefined;
        thumbnailSet = undefined;
        thumbnailSheetSet = undefined;
        title = undefined;
        tmsprogramID = undefined;
        tmsseriesID = undefined;
        topLevelCategory = undefined;
        url = undefined;
        videoPageUrl = undefined;
        videoProperties = undefined;
        videoTitle = undefined;
        vTag = undefined;
        youtubeIds = undefined;
    };
};
